/*
 * @Author: Luis duchanglong@frippler.com
 * @Date: 2022-08-11 18:21:40
 * @LastEditors: Luis duchanglong@frippler.com
 * @LastEditTime: 2022-08-11 18:21:41
 * @FilePath: \mes-web\src\api\em\monitorApi.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/utils/request";

export function equipGetallApi (params) {
  return request({
    url: "?c=em&a=equip&do=getall",
    method: "get",
    params
  });
}

export function getEquipListApi (params) {
  return request({
    url: "?c=em&a=equip&do=list",
    method: "get",
    params
  });
}

export function getEquipApi (params) {
  return request({
    url: "?c=em&a=equip&do=get",
    method: "get",
    params
  });
}

export function postEquipApi (data) {
  return request({
    url: "?c=em&a=equip&do=post",
    method: "post",
    data
  });
}

export function delEquipApi (data) {
  return request({
    url: "?c=em&a=equip&do=del",
    method: "post",
    data
  });
}

export function importEquipApi (data) {
  return request({
    url: "?c=em&a=equip&do=import",
    method: "post",
    data
  });
}

export function exportEquipApi (data) {
  return request({
    url: "?c=em&a=equip&do=export",
    method: "post",
    data
  });
}

export function workshopGetallApi (params) {
  return request({
    url: "?c=em&a=workshop&do=getall",
    method: "get",
    params
  });
}

export function categoryGetallApi (params) {
  return request({
    url: "?c=em&a=category&do=getall",
    method: "get",
    params
  });
}

export function equipMaintainApi (data) {
  return request({
    url: "?c=em&a=equip&do=maintain",
    method: "post",
    data
  })
}

/**
 * @desc: 设备状态统计
 * @param {*} params
 * @return {*}
 */
export function equipStatApi (params) {
  return request({
    url: "?c=em&a=equip&do=stat",
    method: "get",
    params
  });
}


